import { render, staticRenderFns } from "./RenegociacaoDetalhe.vue?vue&type=template&id=165f82a2&"
import script from "./RenegociacaoDetalhe.vue?vue&type=script&lang=js&"
export * from "./RenegociacaoDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports